module.exports = __webpack_public_path__ + "static/media/Left_new2.3c45b564.jpg";